import React, { Component } from 'react';

class PopulationLegend extends Component {
  render() {
    return (
      <div className="gm-slide__results">
        <div className="gm-slide__population-label">Population</div>
        <div className="gm-slide__population-result gm-slide__population-result--party-a">{ this.props.a }</div>
        <div className="gm-slide__population-result gm-slide__population-result--party-b">{ this.props.b }</div>
      </div>
    );
  }
}

export default PopulationLegend;



// WEBPACK FOOTER //
// ./src/components/Shared/PopulationLegend.js